import { Card } from "@/components/ui/Card";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import TicketList from "./components/UserTicketList";

const UserTicketListing = () => {
  useDocumentTitle("Tickets");

  return (
    <div className="w-full p-5 pt-0">
      <TicketList />
    </div>
  );
};

export default UserTicketListing;
